{
  "version": 1,
  "asset_id": "ca744619-b0cc-4ea2-b4f0-e92c27f58f2f",
  "project_id": "7580f3ab-e7a4-418d-abe6-5eb616986e51",
  "url": "/__l5e/assets-v1/ca744619-b0cc-4ea2-b4f0-e92c27f58f2f/lecanto-black-shingle-roof-768w.webp",
  "r2_key": "a/v1/7580f3ab-e7a4-418d-abe6-5eb616986e51/ca744619-b0cc-4ea2-b4f0-e92c27f58f2f/lecanto-black-shingle-roof-768w.webp",
  "original_filename": "lecanto-black-shingle-roof-768w.webp",
  "size": 147440,
  "content_type": "image/webp",
  "created_at": "2026-07-21T19:37:57Z"
}
